<template>
  <div class="purchase-orders" :class="envClass">
    <div class="order-main-info" v-if="hasList">{{ $t('订购主体：') }}{{ mainInfo.name || '-' }}</div>
    <div class="order-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="hasList">
        <van-list
          v-model="uploading"
          :finished="finished"
          :finished-text="$t(`没有更多了`)"
          @load="onLoad"
          :offset="offset"
          :immediate-check="false"
        >
          <div class="order-item" v-for="(item, index) in orderList" :key="index">
            <div class="order-item-header">
              <div class="order-item-sn">{{ $t('套餐编号：') }}{{ item.showId }}</div>
              <div class="order-item-status" :style="{ backgroundColor: item.statusObj.bgColor, color: item.statusObj.color }">
                {{ item.statusObj.name }}
              </div>
            </div>
            <div class="order-item-content">
              <div class="order-item-img">
                <img class="order-package-img" src="../../assets/images/purchase-order-package.png" />
              </div>
              <div class="order-item-article">
                <div class="order-item-title">{{ item.commodityName || '-' }}</div>
                <div class="order-item-aside">
                  <i18n path="已使用：{used}份 剩余：{margin}份" :tag="false">
                    <template slot="used">{{ item.used }}</template>
                    <template slot="margin">
                      <span class="margin">{{ item.margin }}</span>
                    </template>
                  </i18n>
                </div>
                <div class="order-item-expired">{{ $t('截止日期:') }}{{ item.endTimeTxt }}</div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <div class="no-data" v-if="orderList && orderList.length === 0">
        <div class="no-data-img"></div>
        <div class="no-data-desc">
          <div class="marb-8">{{ $t('订购主体：') }}{{ mainInfo.name || '-' }}</div>
          <div>{{ $t('您还没订购过套餐~') }}</div>
        </div>
        <div class="no-data-opration" v-if="showBuyBtn">
          <div class="purchase-btn" @click="submit">{{ $t('订购') }}</div>
        </div>
      </div>
    </div>
    <div class="order-item-footer" v-if="hasList">
      <div class="btn" @click="submit" v-if="showBuyBtn">{{ $t('再次订购') }}</div>
      <div class="btn btn-gray" @click="goHome" v-if="isFromJifei">{{ $t('返回') }}</div>
    </div>
  </div>
</template>
<script>
import { $t, genUrlLang } from '@/locales'
// import { PullRefresh, List, Toast } from 'vant'
import Vue from 'vue'
import mainInfoMixin from './mixin'
import { isIOSClient } from '@/lib/utils'
import { postMessage, setPageTitle, getEnv, navigateBack } from '@esign/esign-plugin/lib/esign-jssdk'
import { sourceChannel, buyProduct } from '@esign/esign-client-jssdk'
const { default: PullRefresh } = require('vant/lib/pull-refresh')
const { default: List } = require('vant/lib/list')
require('vant/lib/pull-refresh/style')
require('vant/lib/list/style')
Vue.use(PullRefresh)
Vue.use(List)
setPageTitle($t('已购套餐'))
export default {
  name: 'OrderList',
  mixins: [mainInfoMixin],
  data() {
    return {
      uploading: false,
      refreshing: false,
      finished: false,
      offset: 100,
      orderList: null,
      pageSize: 10,
      currentPage: 1,
      saas_mini: false,
    }
  },
  computed: {
    hasList() {
      return this.orderList && this.orderList.length > 0
    },
    envClass() {
      if (!this.isFromJifei) return ''

      // 在ios中的支付宝小程序环境下，且版本大于 '10.2.15.60000' 显示返回按钮
      if (this.isIOSAlipayVersionLower()) return ''
      if (['WE_CHAT', 'ALI_PAY_MINI'].includes(this.curEnv)) return 'show-back-btn'

      return ''
    },
    isFromJifei() {
      return this.$route.query.from === 'jifei'
    },
    // 是否展示订购按钮，个人空间 或 企业空间的管理员 为 1展示，其余为 0不展示
    showBuyBtn() {
      return this.$route.query.showBuyBtn !== '0'
    },
  },
  async created() {
    this.init()
    this.checkIsWeChatMini()
    // 通知app 刷新相关数据
    postMessage(
      {
        action: 'refresh',
        params: {
          cannotGoBack: true,
        },
      },
      this.$route.query.client
    )
    this.$tsignData.track('billing_page_display')
    if (this.$route.query.saas_mini === 'true') {
      this.saas_mini = true
    }
  },
  methods: {
    // 在ios中的支付宝小程序环境下，且版本大于 '10.2.15.60000' 显示返回按钮
    isIOSAlipayVersionLower() {
      if (this.$route.query.client === 'ALI_PAY_MINI') {
        if (isIOSClient()) {
          // eslint-disable-next-line no-useless-escape
          const matches = window.navigator.userAgent.match(/AliApp\(AP\/([\d\.]+)\)/i)
          if (!matches[1]) return true
          const arr = matches[1].split('.')
          if (parseInt(arr[0]) >= 10 && parseInt(arr[1]) >= 2 && parseInt(arr[2]) >= 15) return false

          return true
        }
      }

      return false
    },
    async checkIsWeChatMini() {
      this.curEnv = this.$route.query.client || (await getEnv())
    },
    async init() {
      const loading = this.$toast.loading({
        message: $t('加载中...'),
        duration: 0,
      })
      try {
        this.mainInfo = await this.setMainInfo()
        this.orderList = this.mainInfo.realnameStatus ? await this.getOrderList() : []
      } finally {
        loading.clear()
      }
    },
    async getOrderList() {
      const { ouid, guid } = this.mainInfo
      const { data } = await this.$EHttp.api({
        url: `webserver/v1/accounts/${guid}/sys_accountId/${ouid}/auth/orders`,
        method: 'POST',
        body: {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          payStatus: 1,
        },
      })
      const statusMaps = {
        已失效: {
          name: $t('已失效'),
          bgColor: '#F0F0F0',
          color: '#999999',
        },
        待生效: {
          name: $t('待生效'),
          bgColor: '#FFECE3',
          color: '#FA6400',
        },
        生效中: {
          name: $t('生效中'),
          bgColor: '#E7F1FF',
          color: '#1677FF',
        },
        已停用: {
          name: $t('已停用'),
          bgColor: '#F0F0F0',
          color: '#999999',
        },
        已终止: {
          name: $t('已终止'),
          bgColor: '#F0F0F0',
          color: '#999999',
        },
        冻结中: {
          name: $t('冻结中'),
          bgColor: '#FFECE3',
          color: '#E63740',
        },
        交易成功: {
          name: $t('交易成功'),
          bgColor: '#D4FFF1',
          color: '#00B578',
        },
      }

      return data.map((item) => {
        return {
          showId: item.showId,
          status: item.webParameter.status,
          commodityName: item.commodityName,
          used: (item.totalNum || 0) - (item.margin || 0),
          margin: item.margin || 0,
          endTime: item.endTime,
          endTimeTxt: this.formatEndTime(item.endTime),
          statusObj: statusMaps[item.webParameter.status] || {},
        }
      })
    },
    formatEndTime(endTime) {
      if (!endTime) return '--'
      const date = new Date(endTime)
      let month = date.getMonth() + 1
      month = month > 9 ? month : `0${month}`
      let day = date.getDate()
      day = day > 9 ? day : `0${day}`

      return `${date.getFullYear()}/${month}/${day}`
    },
    // 获取url的query的前置symbol
    getUrlSymbol(url) {
      return url.includes('?') ? '&' : '?'
    },
    async submit() {
      const loading = this.$toast.loading({
        message: $t('加载中...'),
        duration: 0,
      })
      try {
        const { data } = await this.$EHttp.api({
          url: `webserver/v1/accounts/sys_accountId/purchaseUrl`,
          method: 'GET',
          headers: {
            'X-Tsign-Client-Id': this.$route.query.client || 'H5',
            'X-Tsign-Open-Tenant-Id': this.orgId || '',
          },
          body: {
            token: this.$route.query.token || '',
          },
        })
        const openIdQuery = `openId=${this.$route.query.openId}`
        const sourceChannelQuery = `source_channel=${sourceChannel}`
        this.$route.query.openId && (data.url += `${this.getUrlSymbol(data.url)}${openIdQuery}`)
        data.url += `${this.getUrlSymbol(data.url)}${sourceChannelQuery}`
        // 生成带语言的链接
        data.url = genUrlLang(data.url)
        buyProduct({
          oid: this.mainInfo.ouid === 'sys_org_id' ? this.mainInfo.base.ouid : this.mainInfo.ouid,
          gid: this.mainInfo.guid,
          buyUrl: encodeURIComponent(data.url),
          returnUrl: encodeURIComponent(this.$route.query.returnUrl || ''),
          vipCode: this.$route.query.vipCode || '',
        })
      } finally {
        loading.clear()
      }
    },
    async onRefresh() {
      try {
        this.currentPage = 1
        this.orderList = await this.getOrderList()
      } finally {
        this.refreshing = false
        this.finished = false
      }
    },
    async onLoad() {
      try {
        this.currentPage++
        const list = await this.getOrderList()
        this.orderList = this.orderList.concat(list || [])
        if (list.length === 0) this.finished = true
      } finally {
        this.uploading = false
      }
    },
    async goHome() {
      console.log('执行返回端的回调')
      // window.my.postMessage({ type: 'navigateBack' })
      // window.my.navigateBack()
      if (this.$route.query.client === 'ALI_PAY_MINI') {
        await getEnv()
        console.log('执行支付宝小程序关闭窗体')
        window.AlipayJSBridge && window.AlipayJSBridge.call('popWindow')
      } else {
        await navigateBack()
      }
      console.log('执行返回端的回调完成!!!')
    },
  },
}
</script>
<style lang="less" scoped>
.purchase-orders {
  padding-top: 72px;
  // padding-bottom: 260px;
  padding-bottom: 128px;
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  &.show-back-btn {
    padding-bottom: 260px;
    .order-item-footer .btn-gray {
      display: block !important;
    }
  }
  .order-main-info {
    position: fixed;
    top: 0;
    left: 0;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 36px;
    padding: 24px;
    z-index: 100;
    background: #f5f5f5;
    width: 100%;
  }
  .order-list {
    height: 100%;
    overflow: auto;
    padding: 0 24px;
    -webkit-overflow-scrolling: touch;
    .order-item {
      padding: 24px;
      background: #ffffff;
      border-radius: 16px;
      margin-bottom: 24px;
      .order-item-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 32px;
        .order-item-sn {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 36px;
        }
        .order-item-status {
          background: #e7f1ff;
          border-radius: 4px;
          padding: 0px 8px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1677ff;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
      }
      .order-item-content {
        display: flex;
        .order-item-img {
          width: 136px;
          height: 136px;
          margin-right: 24px;
          .order-package-img {
            width: 100%;
            height: auto;
          }
        }
        .order-item-article {
          .order-item-title {
            font-size: 30px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 42px;
            margin-bottom: 8px;
          }
          .order-item-aside {
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 36px;
            margin-bottom: 8px;
            .margin {
              color: #e63740;
            }
          }
          .order-item-expired {
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 36px;
          }
        }
      }
    }
    .no-data {
      margin-top: 136px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .no-data-img {
        width: 288px;
        height: 228px;
        background: url('../../assets/images/purchase-no-data.png') no-repeat;
        background-size: cover;
        margin-bottom: 46px;
      }
      .no-data-desc {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 36px;
        margin-bottom: 48px;
        text-align: center;
      }
      .no-data-opration {
        .purchase-btn {
          background: #e63740;
          border-radius: 8px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
          padding: 12px 60px;
          text-align: center;
        }
      }
    }
  }
  .order-item-footer {
    padding: 24px;
    background: #ffffff;
    position: fixed;
    z-index: 100;
    bottom: 0;
    left: 0;
    width: 100%;
    .btn {
      display: block;
      background: #e63740;
      border-radius: 8px;
      padding: 24px;
      text-align: center;
      font-size: 36px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
      // margin-bottom: env(safe-area-inset-bottom);
    }
    .btn-gray {
      margin-top: 24px;
      background: #ffffff;
      border: 1px solid #e5e5e5; /*no*/
      color: #333333;
      display: none;
    }
  }
}
.marb-8 {
  margin-bottom: 8px;
}
</style>
